import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "additional-information-container" }
const _hoisted_2 = { class: "config" }


export default /*@__PURE__*/_defineComponent({
  __name: 'AdditionalInformationWrapper',
  props: {
  color: {
    type: String,
    required: true,
  },
  textColor: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "right-header",
      style: _normalizeStyle({ backgroundColor: __props.color, color: __props.textColor })
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", null, "Additional Information", -1)
    ]))], 4),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ]))
}
}

})